module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_hambúrguer.0fa0c056.png";